// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/footerbg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-cont{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 100%;
    background-size: cover;
    background-position: center;
    color: #ffffff;
}

#foot-sec1{
    display: flex;
    justify-content: center;
    padding: 0% 17.5%;
    margin-bottom: 100px;
}
#foot-sec1>:nth-child(1){
    border-bottom-left-radius: 20px;
}
#foot-sec1>:nth-child(2){
    border-radius: 20px 20px 20px 0px;
}

#sec1-prt1{
    background-color: #0034B0;
    padding: 40px 5%;
    width: 472px;
}

#sec1-prt1>div>h1{
    font-size: 40.5px;
    font-weight: 600;
    width: 80%;
}

#sec1-prt1>div>p{
    font-family: Plus Jakarta Sans;
    font-size: 20.27px;
    font-weight: 500;
    line-height: 29.49px;
}
#sec1-prt1>div>div>img{
    width: 44px;
    height: 44px;
    margin-right: 20px;
}

#sec1-prt1>div>div{
    display: flex;
    justify-content: left;
    align-items: center;
}

#sec1-prt2{
    background-color: #ffffff ;
    width: 668px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    z-index: 2;
    margin-top: -60px;
    position: sticky;
    bottom: -100px;
    color: #000000;
    text-align: left;
    padding: 20px;
    padding-right: 80px;
}

.input-tag-footer{
    height: 50px !important;
    width: 100% !important;
    border-radius: 15px !important;
    border: 1px solid rgb(199, 195, 195) !important;
    padding-left: 30px !important;
}

#phone{
    display: flex;
}

#phone>#phone-no{
    width: 70%;
}

#country-selector{
    padding: 0px 10px;
    width: 30%;
    margin-right: 10px;
    border-radius: 15px;
    border: 1px solid rgb(199, 195, 195);

}

.inputStyle,.containerStyle{
    width: 1000px !important;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input,textarea{
    font-size: 20px;
    font-family: 'Plus Jakarta Sans';
}

#sec1-prt2>form>textarea{
    height: 70px;
    width: 100%;
    padding-left: 30px;
    padding-top: 10px;
    border-radius: 15px;
    border: 1px solid rgb(199, 195, 195);
    font-family: 'Plus Jakarta Sans';
}

#sec1-prt2 :placeholder-shown{
    font-size: 18px;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

#submit-footer-form{
    margin-top: 50px;
    margin-left: 72%;
    width: 200px;
    height: 60px;
    border-radius: 50px;
    border: none;
    background-color: #201D1D;
    color: #ffffff;
}

.foot-tabs>p{
    cursor: pointer;
}

@media (max-width: 1450px){
    #submit-footer-form{
        margin-left: 62%;
    }
}


#foot-sec2{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 10% 50px 10%;
}

#foot-sec2>div>img{
    margin-top: 50px;
    width: 150px;
}


#foot-sec2>div>h2{
    width: 100%;
    /* border: 1px solid red; */
}

#foot-sec2>div>hr{
    height: 300px;
    /* margin-right: 200px; */
}

#foot-sec2>:nth-child(1){
    width: 20%;
}
.foot-tabs>div{
    display: flex;
    gap: 15px;
}
.foot-tabs>div>a>img{
    width: 30px;
}
.foot-tabs>div>:nth-child(3)>img{
    width: 15px;
}

.foot-tabs>div>:nth-child(2)>img{
    width: 35px;
}

.foot-tabs>h3{
    margin-bottom: 30px;
}

#foot-sec3{
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: auto;
    text-align: center;
    /* margin-left: 10%; */   
}

#foot-sec3 a{
        text-decoration: none;
        color: white;
    }


@media (max-width: 1281px){

    #main-cont{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        width: 100%;
        background-size: cover;
        background-position: center;
        margin-top: 0px;
    }

    #foot-sec1{
        display: flex;
        justify-content: center;
        padding: 0%;
        margin-bottom: -100px;
        border-radius: none;
    }

    #sec1-prt1{
        background-color: #0034B0;
        padding: 40px 5%;
        width: 100%;
    }

    #sec1-prt2{
        background-color: #ffffff ;
        width: 90%;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        z-index: 2;
        margin-top:0px;
        position:static;
        bottom: -100px;
        color: #000000;
        text-align: left;
        padding: 20px;
        padding-right: 80px;
        border-radius: none;
        padding-left: 45px;
    }
    
    #foot-sec1>:nth-child(2) {
        border-radius: 0px 0px 20px 0px;
        width: auto;
    }

    #submit-footer-form{
        margin-left: 52%;
    }

    #istab-view{
        display: grid;
        gap: 20px;
        /* text-align: center; */
        grid-template-columns: repeat(2,1fr);
    }
    #foot-sec2{
        display: block;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0 10% 50px 10%;
    }

    #foot-sec2>div>img{
        margin: 140px 0px 30px 45%;
        width: 150px;
        transform: translateX(-50%);
    }

    
    #foot-sec2>div>hr{
        height: 0px;
    }

    #foot-sec2>div>h2{
        display: none;
    }

    #foot-sec2>:nth-child(1){
        width: 100%;
    }
}


@media (max-width: 500px){
    #foot-sec1{
        /* display: block; */
        flex-direction: column;
        justify-content: center;
        padding: 0%;
        margin-bottom: -100px;
        border-radius: none;
    }

    #sec1-prt1{
        background-color: #0034B0;
        padding: 40px 5%;
        width: 90%;
    }
    #foot-sec1>:nth-child(2){
        border-radius: 0px;
    }
    #sec1-prt2{
        background-color: #ffffff ;
        width: 80%;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        z-index: 2;
        margin-top:0px;
        position:static;
        bottom: -100px;
        color: #000000;
        text-align: left;
        padding: 20px;
        padding-right: 80px;
        border-radius: none;
        padding-left: 20px;
    }

    #foot-sec1>:nth-child(1) {
        border-bottom-left-radius: 00px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,yDAA+C;IAC/C,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,iDAAiD;IACjD,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,+CAA+C;IAC/C,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;;AAExC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;QACQ,qBAAqB;QACrB,YAAY;IAChB;;;AAGJ;;IAEI;QACI,yDAA+C;QAC/C,WAAW;QACX,sBAAsB;QACtB,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;QACX,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,UAAU;QACV,iDAAiD;QACjD,UAAU;QACV,cAAc;QACd,eAAe;QACf,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;QAC/B,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,wBAAwB;QACxB,oCAAoC;IACxC;IACA;QACI,cAAc;QACd,8BAA8B;QAC9B,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,YAAY;QACZ,2BAA2B;IAC/B;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,oBAAoB;QACpB,sBAAsB;QACtB,uBAAuB;QACvB,WAAW;QACX,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,kBAAkB;IACtB;IACA;QACI,0BAA0B;QAC1B,UAAU;QACV,iDAAiD;QACjD,UAAU;QACV,cAAc;QACd,eAAe;QACf,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;IACnC;AACJ","sourcesContent":["#main-cont{\r\n    background-image: url(\"../assets/footerbg.jpg\");\r\n    width: 100%;\r\n    background-size: cover;\r\n    background-position: center;\r\n    color: #ffffff;\r\n}\r\n\r\n#foot-sec1{\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 0% 17.5%;\r\n    margin-bottom: 100px;\r\n}\r\n#foot-sec1>:nth-child(1){\r\n    border-bottom-left-radius: 20px;\r\n}\r\n#foot-sec1>:nth-child(2){\r\n    border-radius: 20px 20px 20px 0px;\r\n}\r\n\r\n#sec1-prt1{\r\n    background-color: #0034B0;\r\n    padding: 40px 5%;\r\n    width: 472px;\r\n}\r\n\r\n#sec1-prt1>div>h1{\r\n    font-size: 40.5px;\r\n    font-weight: 600;\r\n    width: 80%;\r\n}\r\n\r\n#sec1-prt1>div>p{\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 20.27px;\r\n    font-weight: 500;\r\n    line-height: 29.49px;\r\n}\r\n#sec1-prt1>div>div>img{\r\n    width: 44px;\r\n    height: 44px;\r\n    margin-right: 20px;\r\n}\r\n\r\n#sec1-prt1>div>div{\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n}\r\n\r\n#sec1-prt2{\r\n    background-color: #ffffff ;\r\n    width: 668px;\r\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n    z-index: 2;\r\n    margin-top: -60px;\r\n    position: sticky;\r\n    bottom: -100px;\r\n    color: #000000;\r\n    text-align: left;\r\n    padding: 20px;\r\n    padding-right: 80px;\r\n}\r\n\r\n.input-tag-footer{\r\n    height: 50px !important;\r\n    width: 100% !important;\r\n    border-radius: 15px !important;\r\n    border: 1px solid rgb(199, 195, 195) !important;\r\n    padding-left: 30px !important;\r\n}\r\n\r\n#phone{\r\n    display: flex;\r\n}\r\n\r\n#phone>#phone-no{\r\n    width: 70%;\r\n}\r\n\r\n#country-selector{\r\n    padding: 0px 10px;\r\n    width: 30%;\r\n    margin-right: 10px;\r\n    border-radius: 15px;\r\n    border: 1px solid rgb(199, 195, 195);\r\n\r\n}\r\n\r\n.inputStyle,.containerStyle{\r\n    width: 1000px !important;\r\n}\r\n\r\ninput[type='number']::-webkit-inner-spin-button,\r\ninput[type='number']::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\ninput,textarea{\r\n    font-size: 20px;\r\n    font-family: 'Plus Jakarta Sans';\r\n}\r\n\r\n#sec1-prt2>form>textarea{\r\n    height: 70px;\r\n    width: 100%;\r\n    padding-left: 30px;\r\n    padding-top: 10px;\r\n    border-radius: 15px;\r\n    border: 1px solid rgb(199, 195, 195);\r\n    font-family: 'Plus Jakarta Sans';\r\n}\r\n\r\n#sec1-prt2 :placeholder-shown{\r\n    font-size: 18px;\r\n    font-family: 'Plus Jakarta Sans', sans-serif;\r\n}\r\n\r\n#submit-footer-form{\r\n    margin-top: 50px;\r\n    margin-left: 72%;\r\n    width: 200px;\r\n    height: 60px;\r\n    border-radius: 50px;\r\n    border: none;\r\n    background-color: #201D1D;\r\n    color: #ffffff;\r\n}\r\n\r\n.foot-tabs>p{\r\n    cursor: pointer;\r\n}\r\n\r\n@media (max-width: 1450px){\r\n    #submit-footer-form{\r\n        margin-left: 62%;\r\n    }\r\n}\r\n\r\n\r\n#foot-sec2{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin: 0 10% 50px 10%;\r\n}\r\n\r\n#foot-sec2>div>img{\r\n    margin-top: 50px;\r\n    width: 150px;\r\n}\r\n\r\n\r\n#foot-sec2>div>h2{\r\n    width: 100%;\r\n    /* border: 1px solid red; */\r\n}\r\n\r\n#foot-sec2>div>hr{\r\n    height: 300px;\r\n    /* margin-right: 200px; */\r\n}\r\n\r\n#foot-sec2>:nth-child(1){\r\n    width: 20%;\r\n}\r\n.foot-tabs>div{\r\n    display: flex;\r\n    gap: 15px;\r\n}\r\n.foot-tabs>div>a>img{\r\n    width: 30px;\r\n}\r\n.foot-tabs>div>:nth-child(3)>img{\r\n    width: 15px;\r\n}\r\n\r\n.foot-tabs>div>:nth-child(2)>img{\r\n    width: 35px;\r\n}\r\n\r\n.foot-tabs>h3{\r\n    margin-bottom: 30px;\r\n}\r\n\r\n#foot-sec3{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 80%;\r\n    margin: auto;\r\n    text-align: center;\r\n    /* margin-left: 10%; */   \r\n}\r\n\r\n#foot-sec3 a{\r\n        text-decoration: none;\r\n        color: white;\r\n    }\r\n\r\n\r\n@media (max-width: 1281px){\r\n\r\n    #main-cont{\r\n        background-image: url(\"../assets/footerbg.jpg\");\r\n        width: 100%;\r\n        background-size: cover;\r\n        background-position: center;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    #foot-sec1{\r\n        display: flex;\r\n        justify-content: center;\r\n        padding: 0%;\r\n        margin-bottom: -100px;\r\n        border-radius: none;\r\n    }\r\n\r\n    #sec1-prt1{\r\n        background-color: #0034B0;\r\n        padding: 40px 5%;\r\n        width: 100%;\r\n    }\r\n\r\n    #sec1-prt2{\r\n        background-color: #ffffff ;\r\n        width: 90%;\r\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n        z-index: 2;\r\n        margin-top:0px;\r\n        position:static;\r\n        bottom: -100px;\r\n        color: #000000;\r\n        text-align: left;\r\n        padding: 20px;\r\n        padding-right: 80px;\r\n        border-radius: none;\r\n        padding-left: 45px;\r\n    }\r\n    \r\n    #foot-sec1>:nth-child(2) {\r\n        border-radius: 0px 0px 20px 0px;\r\n        width: auto;\r\n    }\r\n\r\n    #submit-footer-form{\r\n        margin-left: 52%;\r\n    }\r\n\r\n    #istab-view{\r\n        display: grid;\r\n        gap: 20px;\r\n        /* text-align: center; */\r\n        grid-template-columns: repeat(2,1fr);\r\n    }\r\n    #foot-sec2{\r\n        display: block;\r\n        justify-content: space-between;\r\n        align-items: flex-start;\r\n        margin: 0 10% 50px 10%;\r\n    }\r\n\r\n    #foot-sec2>div>img{\r\n        margin: 140px 0px 30px 45%;\r\n        width: 150px;\r\n        transform: translateX(-50%);\r\n    }\r\n\r\n    \r\n    #foot-sec2>div>hr{\r\n        height: 0px;\r\n    }\r\n\r\n    #foot-sec2>div>h2{\r\n        display: none;\r\n    }\r\n\r\n    #foot-sec2>:nth-child(1){\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 500px){\r\n    #foot-sec1{\r\n        /* display: block; */\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        padding: 0%;\r\n        margin-bottom: -100px;\r\n        border-radius: none;\r\n    }\r\n\r\n    #sec1-prt1{\r\n        background-color: #0034B0;\r\n        padding: 40px 5%;\r\n        width: 90%;\r\n    }\r\n    #foot-sec1>:nth-child(2){\r\n        border-radius: 0px;\r\n    }\r\n    #sec1-prt2{\r\n        background-color: #ffffff ;\r\n        width: 80%;\r\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n        z-index: 2;\r\n        margin-top:0px;\r\n        position:static;\r\n        bottom: -100px;\r\n        color: #000000;\r\n        text-align: left;\r\n        padding: 20px;\r\n        padding-right: 80px;\r\n        border-radius: none;\r\n        padding-left: 20px;\r\n    }\r\n\r\n    #foot-sec1>:nth-child(1) {\r\n        border-bottom-left-radius: 00px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
